// extracted by mini-css-extract-plugin
module.exports = {"summary":"WireTransferPaymentModal_summary__2gO6-","title":"WireTransferPaymentModal_title__1mYSc"};